import { Routes } from '@angular/router';
import { ActivateAccountComponent } from './account/components';
import { LayoutPublicComponent } from './layout/layout-public/layout-public.component';
import { OktaCallbackComponent } from './login/callback.component';
import { LoginComponent } from './login/login.component';

export const publicRoutes: Routes = [
  {
    path: '',
    component: LayoutPublicComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
      },
      {
        path: 'activate-account',
        component: ActivateAccountComponent
      },
      {
        path: 'notify/qid/:routeParam',
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        path: 'notify/rid/:routeParam',
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        path: 'notify/userpref',
        component: LoginComponent,
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/callback',
        component: OktaCallbackComponent
      }
    ]
  }
];
